// extracted by mini-css-extract-plugin
module.exports = {"root":"wrc8W","fullWidth":"_3AccQ"};